/** @jsx dom */
import deepEqual from 'deep-equal';
import dom from 'magic-virtual-element';
import uniqueBy from 'unique-by';
import Badge from '.';

const propTypes = {
	getPrice: {
		source: 'getPrice'
	},
	getTranslation: {
		source: 'getTranslation'
	}
};

const defaultProps = {
	showCampaigns: true,
	showClubBadge: false,
	showSaleOrNew: true
};

const getIconFilename = campaign => {
	const firstProperty = v12.article.properties('camp.icon', campaign.propertyKeys)[0];
	const firstValue = firstProperty && firstProperty.propertyValues[0];

	return (firstValue ? firstValue.propertyvalue : 'default_campaign_icon.png').replace(/^\/media\//, '');
};

const renderCampaigns = ({article, getTranslation, showCampaigns, campaignPopup}) => {
	const header = showCampaigns || getTranslation('article.campaign_title');
	const campagins = uniqueBy(article.articleCampaigns.map(campaign => ({...campaign,
		image: getIconFilename(campaign)
	})), 'image');

	return campagins.map(({camp_desc, camp_id, camp_name, image}) => (
		<Badge key={camp_id} class='BadgeList-item BadgeList-item--campaign' isClickable={campaignPopup} heading={header} subHeading={camp_name} description={camp_desc} image={image}/>
	));
};

const getOnSalePrice = ({article, sku}) => {
	const price = v12.article.price(article, sku);

	return price && price.price_sales < price.price_org ? price : false;
};

const renderSaleOrNew = props => {
	const salePrice = getOnSalePrice(props);

	if (!salePrice) {
		return <Badge key='brand-new-badge' class='BadgeList-item BadgeList-item--brand-new' heading='Brand new' image='brandnew.png'/>;
	}

	if (salePrice) {
		const salesString = props.getPrice(salePrice.price_sales, salePrice.price_sales_exvat);

		return <Badge key='on-sale' class='BadgeList-item BadgeList-item--onSale' heading={props.getTranslation('article.sale')} subHeading={salesString}/>;
	}
};

const shouldUpdate = ({props}, nextProps) => !deepEqual(props, nextProps);

const render = ({props}) => (
	<div class={['BadgeList', props.class]}>
		{props.showClubBadge && <Badge key='club-badge' class='BadgeList-item BadgeList-item--club' image='icon_club_price.png' heading='Club Price'/>}
		{props.showCampaigns && renderCampaigns(props)}
		{props.showSaleOrNew && renderSaleOrNew(props)}
	</div>
);

export default {defaultProps, propTypes, render, shouldUpdate};
